const ShieldedBadge = (function () {
  return {
    init: () => {
      var frameName = new ds07o6pcmkorn({
        openElementId: '#shielded-logo',
        modalID: 'modal',
      })
      frameName.init()
    },
  }
})()

export default ShieldedBadge
